import React from "react";
import PropTypes from "prop-types";
import { UploadTargetBox } from "./UploadTargetBox.js";

export const UploadContainer = ({ onDrop }) => {
  return <UploadTargetBox onDrop={onDrop} />;
};

UploadContainer.propTypes = {
  onDrop: PropTypes.func
};
